// Others
import axiosClient from './axiosClient';
import { urlApiCategory } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { ICategory, ICategoryDetail } from '~/utils/interface/category';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate, IQueryParamBase, IResponseForm } from '~/utils/interface/common';

const categoryApi = {
  getListCategory: (params: IQueryParamBase) => {
    const url = urlApiCategory.getListCategory;
    return axiosClient.get<IBaseResponse<IListDataResponse<ICategory[]>>>(url, { params });
  },

  createCategory: (formData: FormData) => {
    const url = urlApiCategory.createCategory;
    return axiosClient.post<IBaseResponse<IResponseForm>>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getDetailCategory: (id: string) => {
    const url = urlApiCategory.getDetailCategory(id);
    return axiosClient.get<IBaseResponse<ICategoryDetail>>(url);
  },

  deleteCategory: (id: string) => {
    const url = urlApiCategory.deleteCategory(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  updateCategory: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiCategory.updateCategory(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },
};

export default categoryApi;
